import { formatMoney } from "../lib/format.ts";

/** Render a money amount with the optional `GG` suffix; defaults to on. */
export function Money(props: { amount: string | bigint; suffix?: string; class?: string }) {
  const text = () => formatMoney(props.amount);
  const cls = () =>
    ["money", text().startsWith("-") ? "negative" : "positive", props.class]
      .filter(Boolean)
      .join(" ");
  return (
    <span class={cls()}>
      {text()}
      {props.suffix ?? " GG"}
    </span>
  );
}
